import { Action, combineReducers, ThunkAction } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import authReducer from '../features/auth/reducers/auth.reducer';
import delineationReducer from '../features/delineation/reducers/delineation.reducer';
import diagnosticReducer from '../features/diagnostic/reducers/diagnostic.reducer';
import userDiagnosticReducer from '../features/diagnostic/reducers/user-diagnostic.reducer';
import ecgReducer from '../features/ecg/reducers/ecg.reducer';
import ecgListReducer from '../features/ecg/reducers/ecg-list.reducer';
import signalReducer from '../features/ecg/reducers/signal.reducer';
import layoutReducer from '../features/layout/reducers/layout.reducer';
import metricsReducer from '../features/metric/reducers/metric.reducer';
import navigationReducer from '../features/navigation/reducers/navigation.reducer';
import cellReducer from '../features/plot/reducers/cell.reducer';
import stripReducer from '../features/plot/reducers/strip.reducer';
import rulerReducer from '../features/ruler/reducers/ruler.reducer';
import ruler2dReducer from '../features/ruler2d/reducers/ruler2d.reducer';
import scatterReducer from '../features/scatter/reducers/scatter.reducer';
import toolReducer from '../features/tool/reducers/tool.reducer';
import undoReducer from '../features/undo/reducers/undo.reducer';
import createReducer from '../features/wave/reducers/create.reducer';
import updateReducer from '../features/wave/reducers/update.reducer';
import waveReducer from '../features/wave/reducers/wave.reducer';
import { ecgCounterReducer } from '../features/ecg/reducers/ecg-count.reducer';
import annotationReducer from '../features/ecg/reducers/annotation-task.reducer';
import rawSignalReducer from '../features/raw-signal/reducers/raw-signal.reducer';
import episodeMeasurementReducer from '../features/episodeMeasurement/reducers/episode-measurement.reducer';
import analyticsInfoReducer from '../features/analytics/reducer/analytics-info.reducer';
import clusterReducer from '../features/clustering/reducers/cluster.reducer';
import morphologyReducer from '../features/clustering/reducers/morphology.reducer';
import beatsReducer from '../features/beats/beats.reducer';
import adminReducer from '../features/admin/reducers/admin.reducer';
import autoLabelsReducer from '../features/autoLabels/reducers/auto-labels.reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  cell: cellReducer,
  create: createReducer,
  delineation: delineationReducer,
  diagnostic: diagnosticReducer,
  annotationState: annotationReducer,
  ecg: ecgReducer,
  counter: ecgCounterReducer,
  ecgList: ecgListReducer,
  layout: layoutReducer,
  metrics: metricsReducer,
  navigation: navigationReducer,
  ruler: rulerReducer,
  ruler2d: ruler2dReducer,
  scatter: scatterReducer,
  signal: signalReducer,
  strip: stripReducer,
  tool: toolReducer,
  undo: undoReducer,
  update: updateReducer,
  userDiagnostic: userDiagnosticReducer,
  autoLabels: autoLabelsReducer,
  wave: waveReducer,
  rawSignal: rawSignalReducer,
  episodeMeasurement: episodeMeasurementReducer,
  analytics: analyticsInfoReducer,
  cluster: clusterReducer,
  morphology: morphologyReducer,
  beats: beatsReducer,
  admin: adminReducer,
});

export default rootReducer;

export type AppThunk<ReturnType = void, ExtraArgument = null> = ThunkAction<
  ReturnType,
  DefaultRootState,
  ExtraArgument,
  Action<string>
>;

export type AppDispatch = Parameters<AppThunk>[0];
